import React from 'react';
import { useIsEmployeeProfileAccessible } from 'domain/shared/employee';
import EmployeePersonTile, { EmployeePersonTileProps } from './EmployeePersonTile';

const EmployeePersonTileWithAccessCheck = ({ employeeId, isLink = true, ...props }: EmployeePersonTileProps) => {
  const isProfileAccessible = useIsEmployeeProfileAccessible(employeeId);

  return <EmployeePersonTile employeeId={employeeId} isLink={isLink && isProfileAccessible} {...props} />;
};

export default EmployeePersonTileWithAccessCheck;
